import { useCallback } from 'react';
import { LOCAL_ACCOUNTS_BASE_URL } from '../consts';
import { Entity, usePost, UsePostParams } from '../../../../api';
import { AdEntityGuidPayload, BindLocalAccountResponse } from './useBindLocalAccount';

export interface BindLocalAccountsPayload extends AdEntityGuidPayload {
    localAccountGuids: string[];
}

export type BindLocalAccountsResponse = BindLocalAccountResponse;
export type BindLocalAccountsError = unknown;

export type UseBindLocalAccountsParams = UsePostParams<
    BindLocalAccountsPayload,
    BindLocalAccountsResponse,
    BindLocalAccountsError
>;

export const useBindLocalAccounts = (params: UseBindLocalAccountsParams = {}) => {
    const { post, ...rest } = usePost<BindLocalAccountsPayload, BindLocalAccountsResponse, BindLocalAccountsError>(
        params
    );

    const bindLocalAccounts = useCallback(
        (localAccountGuids: string[], entity: Entity) =>
            post(`${LOCAL_ACCOUNTS_BASE_URL}/bind`, {
                localAccountGuids,
                adEntityGuid: entity.guid
            }),
        [post]
    );

    return {
        ...rest,
        bindLocalAccounts
    };
};

export default useBindLocalAccounts;
